const Divisor = () => <hr className="border-slate-200 my-2" />

export default Divisor
